import { RootState } from '../store';

export const getAmount = (state: RootState) => state.global.amountOfRiskWarningElements;
export const getHeaderHeight = (state: RootState) => state.global.headerHeight;
export const getReferrer = (state: RootState) => state.global.referrer;
